import { SVGProps } from 'react';

const LeanTradeIcon = ({
  className,
  style,
  width,
  height,
  fill,
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width || '20'}
    height={height || '20'}
    fill="none"
    className={className}
    style={style}
    viewBox={`0 0 ${width || 20} ${height || 20}`}
    xmlns="http://www.w3.org/2000/svg"
    data-palette="LeanTradeIcon">
    <g clipPath="url(#clip0_812_1087)">
      <path
        d="M6 1.33334V2.66667H3.33333L3.33267 9.33334H12.666L12.6667 2.66667H10V1.33334H13.3333C13.5101 1.33334 13.6797 1.40357 13.8047 1.5286C13.9298 1.65362 14 1.82319 14 2V14C14 14.1768 13.9298 14.3464 13.8047 14.4714C13.6797 14.5964 13.5101 14.6667 13.3333 14.6667H2.66667C2.48986 14.6667 2.32029 14.5964 2.19526 14.4714C2.07024 14.3464 2 14.1768 2 14V2C2 1.82319 2.07024 1.65362 2.19526 1.5286C2.32029 1.40357 2.48986 1.33334 2.66667 1.33334H6ZM12.666 10.6667H3.33267L3.33333 13.3333H12.6667L12.666 10.6667ZM8.66667 1.33334V4.66667H10.6667L8 7.33334L5.33333 4.66667H7.33333V1.33334H8.66667Z"
        fill={fill || 'var(--brand-bg-primary)'}
        stroke="#191A1F"
        strokeWidth="0"
      />
    </g>
    <defs>
      <clipPath id="clip0_812_1087">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LeanTradeIcon;
